export const Params = {
  target: 'target',
  token: 'otutoken'
};
export const TargetType = {
  OLA: 'ola',
  OAO: 'oao'
};
